import panguFormHistory from './panguFormHistory.vue'
export default panguFormHistory
